import { Platform } from 'react-native';
import * as Notifications from 'expo-notifications';
import Constants from 'expo-constants';
import storePushToken from '../requests/Notifications/StorePushToken';

const getPushNotificationsToken = async () => {
  if (Platform.OS !== 'web') {
    if (Platform.OS === 'android') {
      await Notifications.setNotificationChannelAsync('default', {
        name: 'default',
        importance: Notifications.AndroidImportance.MAX,
        vibrationPattern: [0, 250, 250, 250],
        lightColor: '#FF231F7C',
      });
    }
    const { status: existingStatus } = await Notifications.getPermissionsAsync();
    let finalStatus = existingStatus;
    if (existingStatus !== 'granted') {
      const { status } = await Notifications.requestPermissionsAsync();
      finalStatus = status;
    }
    if (finalStatus !== 'granted') {
      // Alert.alert('Failed to get push token for push notification!');
      return;
    }
    Notifications.addNotificationReceivedListener(() => {
      // console.log(n);
    });
    // Alert.alert('Called getPushNotificationsToken');
    const token = (await Notifications.getExpoPushTokenAsync({
      projectId: Constants.expoConfig.extra.eas.projectId,
    })).data;

    // Alert.alert('Your Push Notification Token is:', token);

    if (token) {
      const deviceId = token;
      storePushToken(token, deviceId);
      // console.log('Your Push Notification Token is:', token);
    }
  }
};

export default getPushNotificationsToken;
